<div class="column" *ngIf="vehicleControl.enabled">
    <form [formGroup]="form" novalidate>
        <div class="row small-gutter show-for-large-up">
            <div class="gutter">
                <h4 class="column small-12 large-4 label">
                    <label for="'vehicleRegistration_' + index">
                        {{selectedVehicleText}}* ({{index + 1}})
                    </label>
                </h4>
                <h4 *ngIf="trailerControl.enabled" class="column small-12 large-4 small end">
                    <label [attr.for]="'trailerRegistration_' + index">
                        {{selectedTrailerText}}* ({{index + 1}})
                    </label>
                </h4>
            </div>
            <div class="column small-12">
                <div class="row">
                    <div class="column small-12 large-4">
                        <input type="text" formControlName="vehicleRegistrationNumber" [id]="'vehicleRegistration_' + index" placeholder="{{ 'PASSENGERS_VEHICLE_DETAILS_TYPE' | resource }} {{ 'PASSENGERS_VEHICLE_DETAILS_REGISTRATION' | resource }}" />
                        <span *ngIf="vehicleControl.invalid && vehicleControl.touched" class="field-validation-error">{{'VALIDATION_PASSENGERS_VEHICLE_DETAILS_REGISTRATION_NOT_EMPTY' | resource}}</span>
                    </div>
                    <div *ngIf="trailerControl.enabled" class="column small-12 large-4 end">
                        <input type="text" formControlName="trailerRegistrationNumber" [id]="'trailerRegistration_' + index" placeholder="{{ 'PASSENGERS_VEHICLE_DETAILS_TYPE' | resource }} {{ 'PASSENGERS_VEHICLE_DETAILS_REGISTRATION' | resource }}" />
                        <span *ngIf="trailerControl.invalid && trailerControl.touched" class="field-validation-error">{{'VALIDATION_PASSENGERS_VEHICLE_DETAILS_TRAILER_REGISTRATION_NOT_EMPTY' | resource}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row small-gutter show-for-medium-down">
            <div class="gutter vehicle-section">
                <h4 class="column small-12 quater-gutter label">
                    <label [attr.for]="'vehicleRegistrationSmall_' + index">
                        {{selectedVehicleText}} ({{index + 1}})
                    </label>
                </h4>
                <div class="column small-12 quater-gutter">
                    <input type="text" formControlName="vehicleRegistrationNumber" [id]="'vehicleRegistrationSmall_' + index" placeholder="{{ 'PASSENGERS_VEHICLE_DETAILS_TYPE' | resource }} {{ 'PASSENGERS_VEHICLE_DETAILS_REGISTRATION' | resource }}" />
                    <span *ngIf="vehicleControl.invalid && vehicleControl.touched" class="field-validation-error">{{'VALIDATION_PASSENGERS_VEHICLE_DETAILS_REGISTRATION_NOT_EMPTY' | resource}}</span>
            </div>

                <h4 *ngIf="trailerControl.enabled" class="column small-12 quater-gutter label">
                    <label for="'trailerRegistrationSmall_' + index">
                        {{selectedTrailerText}} ({{index + 1}})
                    </label>
                </h4>
                <div *ngIf="trailerControl.enabled" class="column small-12 quater-gutter">
                    <input type="text" formControlName="trailerRegistrationNumber" [id]="'trailerRegistrationSmall_' + index" placeholder="{{ 'PASSENGERS_VEHICLE_DETAILS_TYPE' | resource }} {{ 'PASSENGERS_VEHICLE_DETAILS_REGISTRATION' | resource }}" />
                    <span *ngIf="trailerControl.invalid && trailerControl.touched" class="field-validation-error">{{'VALIDATION_PASSENGERS_VEHICLE_DETAILS_TRAILER_REGISTRATION_NOT_EMPTY' | resource}}</span>
            </div>
            </div>
        </div>
    </form>
</div>
